import { FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { makeAutoObservable, runInAction } from 'mobx';
import InitiateQuoteFlowDelegate from 'store/flows/initiate-quote/initiateQuoteFlowDelegate';
import { ProposalExperience } from 'store/modules/initiate-quote/types';
import type { DDNJProposalInput } from '../types';

export default class DDNJProposalExperienceStepController {
  private readonly _initiateQuoteFlowDelegate: InitiateQuoteFlowDelegate;
  private readonly _getProposalInput: () => DDNJProposalInput;

  public form: FormController<{
    proposalExperience: FormControl<string>;
  }>;

  public get isValid(): boolean {
    return this.form.basicFieldsValidationsPassed;
  }

  public get proposalExperience(): ProposalExperience | null {
    return this.form.fields.proposalExperience.value
      ? (this.form.fields.proposalExperience.value as ProposalExperience)
      : null;
  }

  // Create a quote for SHELF proposal experience
  public async completeStep(): Promise<void> {
    const { effectiveDate, zip, state, county, proposalName, sic4 } = this._getProposalInput();

    await this._initiateQuoteFlowDelegate.createCartAndSaveProposal({
      effectiveDate,
      proposalName,
      rateSegment: 'GROUP',
      browsingCriteria: {
        effectiveDate,
        zipCode: zip,
        state,
        county,
        sic4,
        shortName: {},
      },
    });

    runInAction(() => {
      this._initiateQuoteFlowDelegate.onCompleteRedirect();
    });
  }

  constructor(initiateQuoteFlowDelegate: InitiateQuoteFlowDelegate, getProposalInput: () => DDNJProposalInput) {
    this._initiateQuoteFlowDelegate = initiateQuoteFlowDelegate;
    this._getProposalInput = getProposalInput;

    this.form = FormController.create(
      {
        proposalExperience: new FormControl<string>('', { optional: false }),
      },
      {},
    );

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
